import { scrollAnimationProgress } from '~scripts/core/animations';

export default function huntflowHelpsItemsInit() {
  const huntflowHelpsItems = document.querySelectorAll('.js-huntflow-helps-item');

  huntflowHelpsItems.forEach((item) => {
    scrollAnimationProgress(item, {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - window.innerHeight;
      },
      getEnd(el, start) {
        const height = el.offsetHeight;
        return start + height * 0.725;
      },
    });
  });
}
